import { GraphQLInt, GraphQLObjectType, GraphQLNonNull } from 'graphql'
import { GradeValueType, GradeValue } from './grade-value'

export interface Grade {
  readonly score: number
  readonly value: GradeValue
}

export const gradeType = new GraphQLObjectType({
  name: 'Grade',
  description:
    'An object with a numerical and letter representation of a grade',
  fields: () => ({
    score: {
      description: 'The numerical value of the grade (0 - 100)',
      type: new GraphQLNonNull(GraphQLInt)
    },
    value: {
      description: 'The letter grade',
      type: new GraphQLNonNull(GradeValueType)
    }
  })
})
